import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreatePartBomController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PartService from "../../Controller/PartController";
import Draggable from 'react-draggable';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';

function CreatePartBOM({ PartID, part, onClose, onSuccess, partList }) {

    const { t } = useTranslation();
    const [formData, setFormData] = useState({ AssetCategory: '' });
    const [selectedRow, setSelectedRow] = useState(null); // State to keep track of selected row
    const [selectedRowIndex, setSelectedRowIndex] = useState(null); // State to keep track of selected row index
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [StockLocationList, setStockLocation] = useState([]);
    const tableRef = useRef();
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (partList.length > 0) {
            initDataTable();
        }
    }, [partList]);
    const fetchStockLocations = async (StockID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, StockID);
            setStockLocation(listOfLocations);
            return listOfLocations; // Return the list of locations
        } catch (error) {
            console.error('Error fetching locations:', error);
            return []; // Return an empty array in case of an error
        }
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (!selectedRow) {
            Swal.fire(
                'Error!',
                'Please select a row to submit.',
                'error'
            );
            return false;
        }
        formData.StockID = PartID;
        formData.selectedPart = selectedRow; // Add selected row data to formData
        const redirectCallback = () => {
            navigate('/');
        };

        if (formData.StockID === selectedRow.PK_Stock_ID.toString()) {
            Swal.fire(
                'Error!',
                'You cannot modify the BOM for this part when there are physical items in the stock.',
                'error'
            );
            return false;
        }

        try {
            const listOfLocations = await fetchStockLocations(selectedRow.PK_Stock_ID);
            const sizeOfList = listOfLocations.length;

            if (sizeOfList === 0) {
                Swal.fire(
                    'Error!',
                    'An error occurred during BOM item insertion. There are no parts location available for when building on this item, please assign a location.',
                    'error'
                );
                return false;

            }

            handleSubmit(event, formData, setFormData, setErrors, () => {
                onSuccess();

            }, () => {
                onSuccess();

            });
        } catch (error) {
            console.error('Error fetching stock locations or submitting form:', error);
        }
    };
    const handleCloseModal = (modal) => {  // Updated function to accept a modal instance
        if (modal) {
            modal.hide();
        }
    };
    const handleRowSelect = (part, index) => {
        setSelectedRow(part);
        setSelectedRowIndex(index);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const truncateText = (text, maxLength = 20) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade partBOMModal show d-block" id="partBOMModal" tabIndex="-1" aria-labelledby="partBOMModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">Create BOM</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                                        <div className="col-sm-12">
                                            <table className="table datatable table-bordered" style={{ "width": "98%", "marginLeft": "0px", "marginRight": "10px", "marginTop": "10px" }} ref={tableRef}>
                                                <thead>
                                                    <tr>
                                                        <th className="no-wrap">Product Code</th>
                                                        <th className="no-wrap">Description</th>
                                                        <th className="no-wrap">Cost Price</th>
                                                        <th className="no-wrap">Sale Price</th>
                                                        <th className="no-wrap">Discount Category</th>
                                                        <th className="no-wrap">In Stock</th>
                                                        <th className="no-wrap">Free Stock</th>
                                                        <th className="no-wrap">On Order</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {partList.map((part, index) => (
                                                        <tr
                                                            key={part.PK_Stock_ID}
                                                            onClick={() => handleRowSelect(part, index)}
                                                            className={selectedRowIndex === index ? 'table-primary' : ''}
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: selectedRowIndex === index ? 'rgb(197, 218, 237)' : 'transparent' // Light green background
                                                            }}
                                                        >
                                                            <td className="no-wrap">{part.vc_StockCode}</td>
                                                            <td className="no-wrap">{truncateText(part.vc_Description)}</td>
                                                            <td className="no-wrap">{part.mon_StockPrice}</td>
                                                            <td className="no-wrap">{part.mon_SalesPrice}</td>
                                                            <td className="no-wrap">{part.FK_StockCategory_ID ? part.FK_StockCategory_ID : "None"}</td>
                                                            <td className="no-wrap">{part.vc_Quantity}</td>
                                                            <td className="no-wrap">{part.vc_FreeStock}</td>
                                                            <td className="no-wrap">{part.vc_OnOrder}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                                    </button>

                                    <button type="button" className="btn btn-danger" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreatePartBOM;
